import { AddressDto } from '@tgg/common-types';

export function addressAsString(address: AddressDto): string {
    return Object.values(address)
        .map((value: string) => (typeof value === 'string' ? value.trim() : ''))
        .filter(Boolean)
        .join(', ');
}
